import React from 'react'
import { useRecipientFilter } from '../../../../../../../contexts/RecipientFilter'
import RFCriteria from './RFCriteria';
import RFOperator from './RFOperator';
import { User } from '@livingdesign/icons';

export const QA_ID_PREFIX = "CriteriaContainer";

function CriteriaContainer({

}) {

  const {
    rawFilter,
    recipientCount,
    parsedFilter,
    handleAddFilter,
    isValid,
  } = useRecipientFilter();

  return (
    <>
      <div
        className='criteria-container'
        data-testid={`${QA_ID_PREFIX}-container`}
      >
        <div
          className='criteria-header'
          data-testid={`${QA_ID_PREFIX}-header`}
        >
          <div data-testid={`${QA_ID_PREFIX}-header-text`}>
            <h3 data-testid={`${QA_ID_PREFIX}-title`}>Set up a rule(s) to apply filters</h3>
            <p
              style={{marginTop: "8px", maxWidth: "700px"}}
              data-testid={`${QA_ID_PREFIX}-description`}
            >
              Create Advanced filters by combining conditions using AND/OR logic. Group conditions to build nested, more precise filtering rules.
            </p>
          </div>
          <div
            className='filtered-recipients-count'
            data-testid={`${QA_ID_PREFIX}-filtered-recipients-count`}
          >
            <User size='small' /> {recipientCount} filtered recipients
          </div>
        </div>
        <div
          style={{marginTop: "16px"}}
          data-testid={`${QA_ID_PREFIX}-filters-section`}
        >
          {parsedFilter.length === 0
            ? <RFCriteria data-testid={`${QA_ID_PREFIX}-criteria-0`} />
            : parsedFilter.map((item, index) => (
                <div
                  key={index}
                  className='filter-item'
                  data-testid={`${QA_ID_PREFIX}-filter-item-${index}`}
                >
                  {item.type === 'condition' ? (
                    <RFCriteria
                      index={index}
                      attribute={item.attribute}
                      values={item.values}
                      data-testid={`${QA_ID_PREFIX}-criteria-${index}`}
                    />
                  ) : (
                    <RFOperator
                      index={index}
                      operator={item.value}
                      data-testid={`${QA_ID_PREFIX}-operator-${index}`}
                    />
                  )}
                </div>
              ))
          }
          <div
            className='add-filter'
            data-testid={`${QA_ID_PREFIX}-add-filter-container`}
          >
            <button
              className='add-filter-btn'
              onClick={handleAddFilter}
              style={{color: isValid ? '#2E2F32' : '#c1c1c1'}}
              data-testid={`${QA_ID_PREFIX}-add-filter-btn`}
            >
              + <u data-testid={`${QA_ID_PREFIX}-add-filter-btn-text`}>Add another attribute</u>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default CriteriaContainer;